import WidgetOrderbox from '@/pages/WidgetOrderbox'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: WidgetOrderbox,
		vueInit: "initializeOrderbox",
	}

	let page = vuewidget(dom, options)
	return page
}
